export default class Job {
  constructor (datetime, store, action) {
    this.datetime = datetime.getTime()
    this.datestr = datetime.toISOString()
    this.store = store
    this.action = action
    this.run = false
    this.running = false
    this.attempts = 0
  }

  static rehydrate (data) {
    let job = new Job(new Date(data.datetime), data.store, data.action)
    job.run = data.run
    job.attempts = data.attempts
    return job
  }

  getId () {
    const date = new Date(this.datetime).toISOString().substring(0, 16)
    return `${date}-${this.store}-${this.action}`
  }

  isRunning () {
    return this.running
  }

  hasBeenRun () {
    return this.run
  }

  isToday () {
    const date = new Date(this.datetime)
    const today = new Date()
    return date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
  }

  isDue () {
    return !this.hasBeenRun() && this.datetime <= new Date().getTime()
  }
}



// WEBPACK FOOTER //
// ./src/models/job.js